export default [
  {
    path: '/obrigacoes-especiais',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Obrigações Especiais Histórico',
        path: 'historico',
        component: () => import('@/views/obrigacoesEspeciais/Historico.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [{ name: 'Power Ups', path: '/powerups' }, { name: 'Obrigações Especiais' }]
        }
      },
      {
        name: 'Obrigações Especiais Adicionar',
        path: 'edit',
        component: () => import('@/views/obrigacoesEspeciais/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Obrigações Especiais', path: '/obrigacoes-especiais/historico' },
            { name: 'Adicionar' }
          ]
        }
      },
      {
        name: 'Obrigações Especiais Editar',
        path: 'edit/:id',
        component: () => import('@/views/obrigacoesEspeciais/Edit.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Power Ups', path: '/powerups' },
            { name: 'Obrigações Especiais', path: '/obrigacoes-especiais/historico' },
            { name: 'Editar' }
          ]
        }
      }
    ]
  }
];
